export default "__VITE_ASSET__GX6nM9mb__"